import { ICellRendererParams } from "ag-grid-community";

export const payorAssignedFacilitiesColumns = [
  {
    headerName: "ID",
    field: "id",
    editable: false,
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
  },
  {
    headerName: "Facility",
    field: "facilityname",
    editable: false,
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
  },
  {
    headerName: "Level 3",
    field: "level3",
    editable: false,
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
  },
  {
    headerName: "Level 2",
    field: "level2",
    editable: false,
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
  },
  {
    headerName: "Level 1",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    field: "level1",
    editable: false,
  },
];
